module.exports = __webpack_public_path__ + "static/media/repairs.14af4083.png";